import React from "react";
import { Button } from "react-bootstrap";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {  Tooltip } from '@mui/material';
import authService from '../../../services/auth/auth.service';

const PhoneExportCSV = ({ grid, fileName, wscols, own_contractor_groups }) => {
  // ******** XLSX with object key as header *************
  // const fileType =
  //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  // const fileExtension = ".xlsx";

  // const exportToCSV = (csvData, fileName) => {
  //   const ws = XLSX.utils.json_to_sheet(csvData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, fileName + fileExtension);
  // };

  // ******** XLSX with new header *************
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const Heading = [
    {
      phone: "Numery telefonów",
     
    }
  ];

  const exportToCSV = (grid, fileName, wscols) => {
    //console.log(csvData)
    
    var csvData = grid.slickGrid.getSelectedRows().map((index)=> {
      
      var ownContractor = authService.isAdmin()
            var tmp = grid.slickGrid.getDataItem(index) 
            if (!ownContractor){
              if (own_contractor_groups &&  Array.isArray(own_contractor_groups) &&  own_contractor_groups.length>0){
                 for (const group in tmp?.group_names_array){
                   if (own_contractor_groups.includes(tmp?.group_names_array[group])){ 
                    ownContractor = true;
                      break;
                   }  
                 }
              }else{
                ownContractor = false;
              }
            }
            if (ownContractor){
              return grid.slickGrid.getDataItem(index)
            }else{
              return {}
            }
    
    });
    if (csvData.length>0){
      const ws = XLSX.utils.json_to_sheet(Heading, {
        header: ["phone"],
        skipHeader: true,
        origin: 0 //ok
      });
      ws["!cols"] = wscols;
      var colPhone = csvData.map(function(value,index) { return {'phone' : value['phone']}; });
      //console.log(colPhone)
      XLSX.utils.sheet_add_json(ws, colPhone, {
        header: ["phone"],
        skipHeader: true,
        origin: -1 //ok
      });
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    }else{
      alert('Wybierz kontrahentów do eksportu!')
    }
  };

  return (

    <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
        onClick={e => exportToCSV(grid, fileName, wscols)}
    >
                <Tooltip title="Telefony do XML">
                <i className="fas fa fa-file-excel-o nav-icon" />
                </Tooltip>
            </button>

  );
};

export default PhoneExportCSV;